export enum DeviceStatusEnum {
    Good = "Good",
    Poor = "Poor",
    ProgrammedOut = "ProgrammedOut",
    Disconnected = "Disconnected"
}
